import { pList } from '../../../../api/models/.catalog';
import { ActionSubTypes } from '../../../ActionSubTypes';
import Api from '../../../../api/ApiWrapper';
import { IApiAction, IPromiseAction } from '../../../../models/ActionModels';
import ActionFunctions from '../../../core/ActionFunctions';
import { IError } from '../../../../models/StateModels';
import { rOyakKiraBilgileriUstBilgiYkgDetay } from '../../../../api/models/rOyakKiraBilgileriUstBilgiYkgDetay';
import rList from '../../../../api/models/rList';

export const action_async_start = (body: pList): IPromiseAction<pList> =>
  ActionFunctions.action_async_start_promise(
    ActionSubTypes.API_OYAKKIRABILGILERIUSTBILGIYKGDETAY,
    new Api.Bilgi.OyakKiraBilgileriUstBilgiYkgDetay().Request(body),
    false,
    false,
    body
  );

export const action_async_complete = (
  data: rList<rOyakKiraBilgileriUstBilgiYkgDetay> | null | undefined,
  error: IError | null | undefined
): IApiAction<rOyakKiraBilgileriUstBilgiYkgDetay[]> =>
  ActionFunctions.action_async_complete_api<rOyakKiraBilgileriUstBilgiYkgDetay[]>(
    ActionSubTypes.API_OYAKKIRABILGILERIUSTBILGIYKGDETAY,
    data?.Values,
    error
  );
